import { ApiError, api } from "@/lib/api";

// Uploads go straight from the browser to the private bucket through a single-use signed URL issued by the backend.
function putWithProgress(url, file, contentType, onProgress) {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open("PUT", url);
    xhr.setRequestHeader("Content-Type", contentType);
    xhr.setRequestHeader("apikey", process.env.REACT_APP_SUPABASE_PUBLISHABLE_KEY);
    xhr.upload.onprogress = (e) => e.lengthComputable && onProgress?.(e.loaded / e.total);
    xhr.onload = () => (xhr.status < 300 ? resolve() : reject(new ApiError(xhr.status, "upload_failed", "The upload failed. Please try again.")));
    xhr.onerror = () => reject(new ApiError(0, "network_error", "The upload was interrupted. Check your connection and try again."));
    xhr.send(file);
  });
}

export async function uploadFile(file, { onProgress } = {}) {
  const { file: record, upload } = await api.post("/files/uploads", { name: file.name, size_bytes: file.size });
  onProgress?.(0);
  await putWithProgress(upload.url, file, upload.content_type, onProgress);
  return api.post(`/files/${record.id}/complete`);
}

// Images to edit in Create Studio: same direct-to-bucket flow, verified by the backend before use.
export async function uploadMediaInput(file, { onProgress } = {}) {
  const { id, upload } = await api.post("/media/inputs", { content_type: file.type, size_bytes: file.size });
  await putWithProgress(upload.url, file, upload.content_type, onProgress);
  return api.post(`/media/inputs/${id}/complete`);
}
